/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useImperativeHandle, useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import {
    exportResourceThreatStatus,
    getResourceThreatStatusEvent
} from 'plugin-codaf-risk-ext-bowtie/services/reportEvents'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'
import { IResourceThreatStatusReport } from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { NoData, NoInfo } from '../../styles'
import { ReportPopover } from '../ReportFilter/ReportPopover'

interface IProps {
    setItemsLength: (k: number) => void
    start: number
    numberOfItems: number
    time: string | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    page: number
    setPage: (k: number) => void
    setExportLoading: (k: boolean) => void
}

interface IOrder {
    field: string
    order: boolean
}

export const ResourceThreatStatus = React.forwardRef<any, IProps>(function ResourceThreatStatus(
    { setPage, setItemsLength, numberOfItems, startDay, startHour, endDay, endHour, page, setExportLoading },
    ref
) {
    const [events, setEvents] = useState<IResourceThreatStatusReport>()
    const [isLoading, setIsLoading] = useState(false)

    const [searchResource, setSearchResource] = useState<string>('')
    const [listResource, setListResource] = useState(new Set<string>())
    const [filterResource, setFilterResource] = useState(new Set<string>())

    const [searchBowtieCode, setSearchBowtieCode] = useState<string>('')
    const [listBowtieCode, setListBowtieCode] = useState(new Set<string>())
    const [filterBowtieCode, setFilterBowtieCode] = useState(new Set<string>())

    const [searchThreatName, setSearchThreatName] = useState<string>('')
    const [listThreatName, setListThreatName] = useState(new Set<string>())
    const [filterThreatName, setFilterThreatName] = useState(new Set<string>())

    const [searchInitialFrequency, setSearchInitialFrequency] = useState<string>('')
    const [listInitialFrequency, setListInitialFrequency] = useState(new Set<string>())
    const [filterInitialFrequency, setFilterInitialFrequency] = useState(new Set<string>())

    const [searchFinalFrequency, setSearchFinalFrequency] = useState<string>('')
    const [listFinalFrequency, setListFinalFrequency] = useState(new Set<string>())
    const [filterFinalFrequency, setFilterFinalFrequency] = useState(new Set<string>())

    const [searchDate, setSearchDate] = useState<string>('')
    const [listDate, setListDate] = useState(new Set<string>())
    const [filterDate, setFilterDate] = useState(new Set<string>())

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const [update, setUpdate] = useState<number>(0)

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const formatedDate = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${formatedDate}`
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reportEvent) {
            const renderObject = events?.reportEvent.map((item, index) => {
                return (
                    <tr key={index} className={`resource-threat-status ${index === 0 ? 'first-margin' : ''}`}>
                        <td valign="middle" className="common-width">
                            {item.resource}
                        </td>
                        <td valign="middle" className="common-width">
                            {item.bowtieCode}
                        </td>
                        <td valign="middle" className="common-width diff-size">
                            {item.threatName}
                        </td>
                        <td valign="middle" className="common-width">
                            {item.initialFrequency}
                        </td>
                        <td valign="middle" className="common-width">
                            {item.finalFrequency}
                        </td>
                        <td valign="middle" className="common-width">
                            {dateConverter(item.date)}
                        </td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const formatSetToArray = (setToFormat: Set<string>): string[] => {
        const arr = []
        setToFormat.forEach(item => {
            arr.push(item)
        })

        return arr
    }

    const convertDateToTs = (dateToTs: Set<string>): string[] => {
        const arr = []
        dateToTs.forEach(item => {
            const dateFormating = new Date(item).getTime()
            arr.push(dateFormating)
        })

        return arr
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const threatEvents = await getResourceThreatStatusEvent({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: formatSetToArray(filterResource),
                filterByBowtieCode: formatSetToArray(filterBowtieCode),
                filterByThreatName: formatSetToArray(filterThreatName),
                filterByInitialFrequency: formatSetToArray(filterInitialFrequency),
                filterByFinalFrequency: formatSetToArray(filterFinalFrequency),
                filterByDate: convertDateToTs(filterDate)
            })
            setEvents(threatEvents)
            setItemsLength(threatEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const onClearAllFilters = (): void => {
        setUpdate(update + 1)
        globalNotification.success(i18n('Filters removed successfully.'))
    }

    useImperativeHandle(ref, () => ({
        async exportResourceThreatStatus() {
            try {
                setExportLoading(true)
                await exportResourceThreatStatus({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    page: page,
                    perPage: numberOfItems,
                    sortBy: order.field,
                    sortOrder: order.order ? 'ASC' : 'DESC',
                    filterByResource: formatSetToArray(filterResource),
                    filterByBowtieCode: formatSetToArray(filterBowtieCode),
                    filterByThreatName: formatSetToArray(filterThreatName),
                    filterByInitialFrequency: formatSetToArray(filterInitialFrequency),
                    filterByFinalFrequency: formatSetToArray(filterFinalFrequency),
                    filterByDate: convertDateToTs(filterDate)
                })
                globalNotification.success(i18n('Report exported successfully.'))
            } catch (error) {
                globalNotification.error(i18n('Error on exporting report.'))
            } finally {
                setExportLoading(false)
            }
        }
    }))

    useEffect(() => {
        getEvents()
    }, [
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        order,
        filterResource,
        filterBowtieCode,
        filterThreatName,
        filterInitialFrequency,
        filterFinalFrequency,
        filterDate
    ])

    useEffect(() => {
        setPage(1)
    }, [
        order,
        filterResource,
        filterBowtieCode,
        filterThreatName,
        filterInitialFrequency,
        filterFinalFrequency,
        filterDate
    ])

    return (
        <>
            <button className="clearAllFilters" onClick={() => onClearAllFilters()}>
                {i18n('Clear all filter view')}
                <i className="far fa-filter"></i>
            </button>
            <div className="tableContainer customScroll">
                <table>
                    <thead className="tableHeader">
                        <tr className="resource-threat-status-header">
                            <th className="common-width">
                                <ReportPopover
                                    search={searchResource}
                                    setSearch={setSearchResource}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESOURCE}
                                    list={listResource}
                                    setList={setListResource}
                                    filter={filterResource}
                                    setFilter={setFilterResource}
                                    onClearAll={update}
                                    buttonTitle={'resource'}
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchBowtieCode}
                                    setSearch={setSearchBowtieCode}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIECODE}
                                    list={listBowtieCode}
                                    setList={setListBowtieCode}
                                    filter={filterBowtieCode}
                                    setFilter={setFilterBowtieCode}
                                    onClearAll={update}
                                    buttonTitle="bowtie code"
                                />
                            </th>
                            <th className="common-width diff-size">
                                <ReportPopover
                                    search={searchThreatName}
                                    setSearch={setSearchThreatName}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.THREAT_NAME}
                                    list={listThreatName}
                                    setList={setListThreatName}
                                    filter={filterThreatName}
                                    setFilter={setFilterThreatName}
                                    onClearAll={update}
                                    buttonTitle="threat name"
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchInitialFrequency}
                                    setSearch={setSearchInitialFrequency}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.INITIAL_FREQUENCY}
                                    list={listInitialFrequency}
                                    setList={setListInitialFrequency}
                                    filter={filterInitialFrequency}
                                    setFilter={setFilterInitialFrequency}
                                    onClearAll={update}
                                    buttonTitle="initial frequency"
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchFinalFrequency}
                                    setSearch={setSearchFinalFrequency}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.FINAL_FREQUENCY}
                                    list={listFinalFrequency}
                                    setList={setListFinalFrequency}
                                    filter={filterFinalFrequency}
                                    setFilter={setFilterFinalFrequency}
                                    onClearAll={update}
                                    buttonTitle="final frequency"
                                />
                            </th>
                            <th className="common-width">
                                <ReportPopover
                                    search={searchDate}
                                    setSearch={setSearchDate}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.DATE}
                                    list={listDate}
                                    setList={setListDate}
                                    filter={filterDate}
                                    setFilter={setFilterDate}
                                    onClearAll={update}
                                    buttonTitle="date/time"
                                    last
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <NoInfo>
                                <i className="fa fa-spinner fa-spin" />
                            </NoInfo>
                        ) : events?.total === 0 ? (
                            <NoData>{i18n('There is no data for the specified period.')}</NoData>
                        ) : (
                            renderTableRow()
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
})
